/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { Vesting } from "../Vesting";

export class Vesting__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Vesting> {
    return super.deploy(overrides || {}) as Promise<Vesting>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Vesting {
    return super.attach(address) as Vesting;
  }
  connect(signer: Signer): Vesting__factory {
    return super.connect(signer) as Vesting__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Vesting {
    return new Contract(address, _abi, signerOrProvider) as Vesting;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressAddedToWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "removedWhitelistAddress",
        type: "address",
      },
    ],
    name: "AddressRemovedFromWhitelist",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addAddressToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "end",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "vestingPerSec",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "onStartAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "previousAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimedV1",
            type: "uint256",
          },
        ],
        internalType: "struct Vesting.VestingInfo",
        name: "vestingInfo",
        type: "tuple",
      },
      {
        internalType: "bytes32[]",
        name: "merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "end",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "vestingPerSec",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "onStartAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "previousAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimedV1",
            type: "uint256",
          },
        ],
        internalType: "struct Vesting.VestingInfo",
        name: "vestingInfo",
        type: "tuple",
      },
    ],
    name: "getClaimableAmountFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_merkleRoot",
        type: "bytes32",
      },
      {
        internalType: "address[]",
        name: "_whitelistAddresses",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_staking",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "merkleRoot",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "recipientClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeAddressFromWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "root",
        type: "bytes32",
      },
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staking",
        type: "address",
      },
    ],
    name: "setStakingContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "end",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "vestingPerSec",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "onStartAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "previousAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimedV1",
            type: "uint256",
          },
        ],
        internalType: "struct Vesting.VestingInfo",
        name: "vestingInfo",
        type: "tuple",
      },
      {
        internalType: "uint16",
        name: "stakingOption",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "ownAmount",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "stakeOwnAndVestedTokensWithApprove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "end",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "vestingPerSec",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "onStartAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "previousAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimedV1",
            type: "uint256",
          },
        ],
        internalType: "struct Vesting.VestingInfo",
        name: "vestingInfo",
        type: "tuple",
      },
      {
        internalType: "uint16",
        name: "stakingOption",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "ownAmount",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "merkleProof",
        type: "bytes32[]",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "stakeOwnAndVestedTokensWithPermit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "end",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "vestingPerSec",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "onStartAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "previousAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimedV1",
            type: "uint256",
          },
        ],
        internalType: "struct Vesting.VestingInfo",
        name: "vestingInfo",
        type: "tuple",
      },
      {
        internalType: "uint16",
        name: "stakingOption",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "autorenew",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "claimAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "stakingAmount",
        type: "uint256",
      },
      {
        internalType: "bytes32[]",
        name: "merkleProof",
        type: "bytes32[]",
      },
    ],
    name: "stakeVestedTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "staking",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenBUMP",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "start",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "end",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "cliff",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "vestingPerSec",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "onStartAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "previousAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "claimedV1",
            type: "uint256",
          },
        ],
        internalType: "struct Vesting.VestingInfo",
        name: "vestingInfo",
        type: "tuple",
      },
    ],
    name: "totalLockedOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
